import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const lookupManifest: FeatureManifest = {
  id: 'english-language-standards-lookup',
  path: 'english-knowledge/lookup/*',
  navPath: '/english-knowledge/lookup',
  label: 'Tra cứu',
  description: 'Tra cứu tiêu chuẩn, tìm kiếm và kiểm tra mã tham chiếu',
  navigationGroup: { id: 'english-skills', label: 'Tiêu chuẩn' },
  load: () => import('./entry'),
}
